import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import '../styles/AboutSlidingSection.css';

const About = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="about-sliding-section">
        <motion.img
          src={require('../images/raw1.png')}
          alt="KAPARELOS TRANS Truck"
          className="about-image"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        />
        <motion.div
          className="about-text"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
        >
          <p style={{ color: '#fbfbec' }}>{t('about.slidingText')}</p>
        </motion.div>
      </div>
    </>
  );
};

export default About;
